import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import {authservices} from '../../services/authServices';

const Register = () => {
  const [initialvalues, setInitialValues] = useState({
    name: '',
    email: '',
    password: '',
    c_password: '',
  });

  const [passwordError, setPasswordError] = useState('');
  const toast = useRef(null);
  const navigate = useNavigate();

  const onChange = (e) => {
    setInitialValues({ ...initialvalues, [e.target.name]: e.target.value });
  };

  const registeruser = (e) => {
    e.preventDefault();
    setPasswordError('');

    if (initialvalues.password !== initialvalues.c_password) {
      setPasswordError('Password and Confirm Password do not match.');
      return;
    }

    authservices.register(initialvalues).then((response) => {
		console.log(response)
      console.log("Response:", response.data.data);

      if (response.data.status === 200) {
        toast.current.show({
          severity: 'success',
          summary: 'Register',
          detail: 'Account created successfully!',
        });

        setTimeout(() => {
          navigate('/login');
        }, 2000);

      } else {
        toast.current.show({
          severity: 'error',
          summary: 'Register Failed',
          detail: response.data?.data || 'Something went wrong.',
        });
      }
    }).catch((error) => {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Registration failed. Please try again.',
      });
      console.error(error);
    });
  };

  return (
    <>
      <Toast ref={toast} />
	  <div className="login-page">
		<div className="login-left">
			<img
                                    src="utan logo.png"
                                    alt="navbar brand"
                                    className="navbar-brand"
                                    height="80"
                                />
			<h1>Welcome Back</h1>
			<p>Access your dashboard</p>
		</div>
		<div className="login-right">
			<form onSubmit={registeruser}>
			<h2>Sign Up</h2>
			<input
                id="name"
                name="name"
                type="text"
                className="form-control"
                placeholder="Name"
                required
                onChange={onChange}
              />
			  <input
                id="email"
                name="email"
                type="email"
                className="form-control"
                placeholder="Email"
                required
                onChange={onChange}
              />
			  <input
                id="password"
                name="password"
                type="password"
                className="form-control"
                placeholder="Password"
                required
                onChange={onChange}
              />
			   <input
                id="c_password"
                name="c_password"
                type="password"
                className="form-control"
                placeholder="Confirm Password"
                required
                onChange={onChange}
              />
			  {passwordError && (
                <div style={{ color: 'red', marginTop: '5px' }}>{passwordError}</div>
              )}
			
			<button type="submit">Sign Up</button>
			<div className="links">
				
				<a href="/">Sign In</a>
			</div>
			</form>
		</div>
	</div>
	{/* <div className="login bg-primary">
		<div className="wrapper wrapper-login">
      <form onSubmit={registeruser} className="login100-form validate-form">
        <div className="container container-login animated fadeIn">
          <h3 className="text-center">Sign Up</h3>
          <div className="login-form">
            <div className="form-floating form-floating-custom mb-3">
              <input
                id="name"
                name="name"
                type="text"
                className="form-control"
                placeholder="Name"
                required
                onChange={onChange}
              />
              <label htmlFor="name">Name</label>
            </div>

            <div className="form-floating form-floating-custom mb-3">
              <input
                id="email"
                name="email"
                type="email"
                className="form-control"
                placeholder="Email"
                required
                onChange={onChange}
              />
              <label htmlFor="email">Email</label>
            </div>

            <div className="form-floating form-floating-custom mb-3">
              <input
                id="password"
                name="password"
                type="password"
                className="form-control"
                placeholder="Password"
                required
                onChange={onChange}
              />
              <label htmlFor="password">Password</label>
            </div>

            <div className="form-floating form-floating-custom mb-3">
              <input
                id="c_password"
                name="c_password"
                type="password"
                className="form-control"
                placeholder="Confirm Password"
                required
                onChange={onChange}
              />
              <label htmlFor="c_password">Confirm Password</label>
              {passwordError && (
                <div style={{ color: 'red', marginTop: '5px' }}>{passwordError}</div>
              )}
            </div>

            <div className="form-action mb-3">
  <button type="submit" className="btn btn-primary w-100 btn-login">
    Sign Up
  </button>
</div>

<div className="form-action text-center">
  <p className="mb-0">
    Already have an account?{' '}
    <a href="/login" className="btn btn-link p-0">
      Sign In
    </a>
  </p>
</div>

          </div>
        </div>
      </form>
	  </div>
	  </div> */}
    </>
  );
};

export default Register;
